import React from "react";
import { Form } from "react-bootstrap";
import { CcAssessmentPathwayEnrollmentCertificate } from "../Models/CcAssessmentPathwayEnrollment";


interface IProps{
    abccCertificates: Array<CcAssessmentPathwayEnrollmentCertificate>;
    updateCertificateAttestation: (certificate: CcAssessmentPathwayEnrollmentCertificate) => void;
}

export default function ArticlePathwayTerms(props: IProps){
    
    const updateCertificateAttestations = (e: React.ChangeEvent<HTMLInputElement>) => {
        for (var i = 0; i < props.abccCertificates.length; i++){
            var updated = props.abccCertificates[i];
            updated.ccAssessmentAttestationDate = e.target.checked ? new Date().toString() : null;
            props.updateCertificateAttestation(updated);
        }
    }


    return (
        <React.Fragment>
                <Form.Group>
                    <Form.Text className="font-weight-bold">Article-Based Continuing Certification (ABCC) Pathway Attestation</Form.Text>
                </Form.Group>
                <Form.Group>
                    <div className="pp-assessment-terms-body">
                        <p>
                            I attest that I have chosen the ABCC pathway to satisfy the Continuing Certification (CC) recertification exam requirement. 
                            I agree that to meet the CC recertification exam requirement via the ABCC pathway, I must successfully complete a set of article 
                            exams for each of my ABPN certificates on an ongoing basis for three consecutive 3-year blocks. I also agree that to maintain my 
                            ABPN certification(s) I must also successfully complete the CC Activity Requirements, pay an annual fee, and maintain a valid and 
                            unrestricted medical license. (For an overview see <a href="https://abpn.org/continuing-certification/">https://abpn.org/continuing-certification/</a>.) 
                            I agree that if I fail to successfully complete three (3) three-year ABCC blocks by the end of year 9, I understand I will be automatically transferred to the 
                            Recertification Exam pathway and will need to successfully pass the Recertification Exam by the end of my 10-year recertification block.
                        </p>

                        <p>
                            Qualifications for ABCC pathway accommodations for applicants with disabilities can be found on the ABPN website policies 
                            section: <a href="https://abpn.org/wp-content/uploads/2024/01/ABCC-Applicants-with-Disabilities.pdf">https://abpn.org/wp-content/uploads/2024/01/ABCC-Applicants-with-Disabilities.pdf</a>. 
                            Please note, however, that applications for accommodations must be submitted by February 1 of every 3-year block. I understand that requests for 
                            changes in the duration of a 3-year block, extensions to a 3-year block, the number of article exams needing to be successfully 
                            completed, or any other alteration in the grading or assessment will be deemed to fundamentally alter the measurement of the 
                            skills or knowledge being assessed and will not be granted by the ABPN.
                        </p>

                        <p>
                            I agree the Board is the final judge of my qualification for holding ABPN certification(s) and that I must adhere to the 
                            Board's applicable policies (see <a href="https://abpn.org/about/policies/">https://abpn.org/about/policies/</a>).</p>

                        <p>
                            I agree to fully adhere to the Board's policy on Irregular Behavior, Including Unethical Behavior of Candidates 
                            (<a href="https://www.abpn.org/wp-content/uploads/2022/07/Policy-Regarding-Irregular-Behavior.pdf">https://www.abpn.org/wp-content/uploads/2022/07/Policy-Regarding-Irregular-Behavior.pdf</a>), 
                            and that I will not share questions or answers included in the ABCC examinations. I agree that I will not choose ABCC journal articles
                                for which I was an author or contributor. Irregular or improper behaviors, as evidenced by observation, by subsequent statistical analysis, or by 
                            other means, may be cause for the Board to terminate my examination, invalidate my examination results, bar me from admission
                            to future examinations or certification, and to take other appropriate actions.
                        </p>

                        <p>
                            I understand that the Board makes academic and scientific judgments in its evaluation of the results of its examinations, and that 
                            situations may occur, even through no fault of mine, that will render my examination results unreliable in the judgement of the Board.
                            I agree that if the Board determines that the results of my examination are unreliable, the Board may require me to retake that examination.
                        </p>

                        <p>
                            See the website for additional information about the Article Based Continuing Certification (ABCC) pathway here: 
                            <a href="https://abpn.org/continuing-certification/article-based-continuing-certification-pathway-abcc/">https://abpn.org/continuing-certification/article-based-continuing-certification-pathway-abcc/</a>
                        </p>

                        <p>
                            See the General Policies regarding taking a CC / recertification examination here: <a href="https://abpn.org/continuing-certification/continuing-certification-exams/">https://abpn.org/continuing-certification/continuing-certification-exams/</a>
                        </p>
                    </div>
                </Form.Group>
                <Form.Group controlId="articelsFormAttestationControls">
                    <Form.Check type="checkbox">
                        <Form.Check.Input defaultChecked={false}  type="checkbox" required onChange={updateCertificateAttestations} />
                        <Form.Check.Label><strong>I hereby declare under penalty of perjury I agree to the terms and conditions of the Article Based Continuing Certification (ABCC) Pathway. I intend to be legally bound by the foregoing.</strong></Form.Check.Label>
                        <Form.Control.Feedback type="invalid">Please attest to the above before continuing</Form.Control.Feedback>
                    </Form.Check>
                </Form.Group>
            </React.Fragment>
    );
}